import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {LawTransactionsRow} from "../types";

export interface LawTransactionsState {
  listLoading: boolean;
  actionsLoading: boolean;
  totalCount: number;
  pageCount: number;
  entities: LawTransactionsRow[] | null;
  totalPaid: number;
  error: string | null;
}

export interface Payload {
  totalCount: number;
  pageCount: number;
  entities: LawTransactionsRow[];
  totalPaid: number
}

export const callTypes = {
  list: "list",
  action: "action",
} as const;


const initialLawTransactionsState: LawTransactionsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  totalPaid: 0,
  error: null,
};

export const lawTransactionsSlice = createSlice({
  name: "lawTransactions",
  initialState: initialLawTransactionsState,
  reducers: {
    lawTransactionsFetched: (
      state,
      action: PayloadAction<Payload>
    ) => {
      const { totalCount, pageCount, entities, totalPaid } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.totalPaid = totalPaid;
    },
    lawTransactionsAppended: (
      state,
      action: PayloadAction<Payload>
    ) => {
      const { totalCount, pageCount, entities, totalPaid } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities
        ? [...state.entities, ...entities]
        : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
      state.totalPaid = totalPaid;
    },
    catchError: (
      state,
      action: PayloadAction<{ error: string; callType: typeof callTypes.list | typeof callTypes.action }>
    ) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (
      state,
      action: PayloadAction<{ callType: typeof callTypes.list | typeof callTypes.action }>
    ) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  },
});

export const { lawTransactionsFetched, lawTransactionsAppended, catchError, startCall } = lawTransactionsSlice.actions;